var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, Fragment, createElement } from 'react';
import { Link } from 'react-router-dom';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { connect, useSelector } from 'react-redux';
import { Alert } from 'react-bootstrap';
import { transform } from 'js/css-transform';
import HTML from 'html-parse-stringify';
import _ from 'lodash';
import he from 'he';
import { isExternal } from 'helpers/http';
import DropdownElementFTs from 'cc-editor/components/BlockTs/DropdownElementFTs';
import QRCodeWithLogoFTs from 'cc-editor/components/BlockTs/QRCodeWithLogoFTs';
import BackgroundElementFTs from './BlockTs/BackgroundElementFTs';
import ImageElementFTs from './BlockTs/ImageElementFTs';
import EditableFTs from './BlockTs/EditableFTs';
import BlockContainerFTs from './BlockTs/BlockContainerFTs';
import DraggableContainerFTs from './BlockTs/DraggableContainerFTs';
import QRCode from './Block/QRCode';
import { getCorporateDesignClient, getCorporateDesignLogoUrl } from 'cc-editor/helpers/corporateDesign';
/*
  import NavigationElement from './BlockWebsite/NavigationElement';
  import CalendarElement from './BlockWebsite/CalendarElement';
  import CalendarElementOptimized from './BlockWebsite/CalendarElementOptimized';
  import VideoElement from './BlockWebsite/VideoElement';
  import SocialMediaElement from './BlockWebsite/SocialMediaElement';
  import ImageGalleryElement from './BlockWebsite/ImageGalleryElement';
  import ImageGalleryElementTwo from './BlockWebsite/ImageGalleryElementTwo';
  import ContactFormElement from './BlockWebsite/ContactFormElement';
  import RSSFeedsElement from './BlockWebsite/RSSFeedsElement';
  import TextSlider from './BlockWebsite/TextSlider';
  import TextSliderTwo from './BlockWebsite/TextSliderTwo';
  import ContactFormElementNew from './BlockWebsite/ContactFormElementNew';
  import GoogleMapsElement from './BlockWebsite/GoogleMapsElement';
  import Calendly from './BlockWebsite/Calendly';
  import ActionButton from './Block/ActionButton';
  import Creatomate from './Block/Creatomate';
 */
import withRouter from 'js/withRouter';
const EditorBlockFTs = (props) => {
    const { data, bgColor, updateParam, appIntl } = props;
    const intl = appIntl; // or useIntl(); but then we have to use another depth appIntl?.messages? instead of appIntl?.messages?.messages ?? {};
    const editionRV = useSelector((state) => state.editor.editionRV);
    const qrVariables = React.useMemo(() => {
        var _a;
        const profile = ((_a = getCorporateDesignClient(editionRV)) === null || _a === void 0 ? void 0 : _a.profile) || {};
        const website = profile.website ? String(profile.website).replace(/^https?:\/\//, '') : '';
        return {
            website,
            companyName: profile.company,
            addCompanyName: profile.company_name,
            street: profile.street,
            zipCode: profile.zip_code,
            city: profile.city,
            phone: profile.phone,
            email: profile.email,
            slogan1: profile.slogan1,
            slogan2: profile.slogan2,
            herausgeber: props.publisherInfo,
        };
    }, [editionRV, props.publisherInfo]);
    const [elementToChange, setElementToChange] = useState('');
    const [bgColorE, setBgColorE] = useState('');
    const [startUpdate, setStartUpdate] = useState(false);
    const [startChangeBackground, setStartChangeBackground] = useState(false);
    const [dataNameE, setDataNameE] = useState('');
    const forbiddenTags = ['iframe', 'script'];
    const allowedAttributes = ['class', 'style', 'colspan', 'href', 'target', 'src', 'alt'];
    const getElementToChange = (element) => setElementToChange(element);
    const getLinkData = ({ name, attributes }) => {
        const isLinkExternal = isExternal(attributes.href);
        const decodedHref = he.decode(attributes.href);
        return {
            name: isLinkExternal ? name : Link,
            attributes: Object.assign(Object.assign({}, attributes), (isLinkExternal
                ? { href: decodedHref }
                : { to: decodedHref })),
        };
    };
    const containsMatchingEditable = (node, targetName) => {
        if (!node || !targetName)
            return false;
        if (node.type === 'tag' && node.attrs) {
            const nodeClass = node.attrs.class || '';
            const nodeDataName = node.attrs['data-name'];
            if (nodeClass.includes('editable') && nodeDataName === targetName) {
                return true;
            }
        }
        if (Array.isArray(node.children)) {
            return node.children.some((child) => containsMatchingEditable(child, targetName));
        }
        return false;
    };
    const loop = (elements) => {
        const { index, updateInnerBlock, pageZoom, settings, imageUpload, usedMedia, zoomEqualizer, type, copyBlock, pasteBlock, templateBlocks, containerSelect, blockContainer, rasterV, pasteData, copiedBlock, unsetBlockContainer, navEntry, resetNavEntry, publisherInfo, rootUser, wlAdminUser, isSubmission, onlyWhitelabelAdminCanModifyBlocks, showKeyboard, saveDescription, filesUploading, resizeBlock, blockBiggerDisable, getDeviceType, blockPasteDisableBlockContainer, currentPage, setSelectedColor, getColorSettings, deleteSelectedColor, colorSettings, setFontSizeSettings, fontSizeSettings, updateSpecialBlockAttributes, blockContainerId, autoResizeSupported, updateBlocksState, setSelectedObjectForAI, selectedObjectForAI, } = props;
        let result = [];
        let bgColorParam = '';
        let counter = 0;
        _.forEach(elements, (value, key) => {
            var _a, _b;
            counter++;
            if (value.type === 'text') {
                result.push(he.decode(value.content));
                return;
            }
            if (value.type === 'tag' && !_.includes(forbiddenTags, value.name)) {
                let { name } = value;
                let attributes = { key };
                // Background detection (data-background meta in param)
                if (value.attrs && value.attrs.hasOwnProperty('data-background')) {
                    _.forEach(data.params, (param) => {
                        if (param.name === value.attrs['data-name']) {
                            const parsedParam = HTML.parse(param.value);
                            _.forEach(parsedParam, (paramContent) => {
                                if (paramContent.name === 'meta') {
                                    bgColorParam = paramContent.attrs.content;
                                }
                                else {
                                    bgColorParam = bgColor;
                                }
                            });
                        }
                    });
                }
                _.forEach(value.attrs, (attr, attrKey) => {
                    switch (attrKey) {
                        case 'class':
                            attributes.className = attr;
                            break;
                        case 'contenteditable':
                            attributes.contentEditable = attr;
                            break;
                        case 'colspan':
                            attributes.colSpan = attr;
                            break;
                        case 'rowspan':
                            attributes.rowSpan = attr;
                            break;
                        case 'style':
                            if (attr) {
                                try {
                                    attributes[attrKey] = transform(attr);
                                }
                                catch (err) {
                                    console.log('error', err);
                                }
                            }
                            break;
                        case 'data-background':
                            attributes.className = [`${attributes.className} ${bgColorParam}`].join();
                            attributes[attrKey] = attr;
                            break;
                        default:
                            attributes[attrKey] = attr;
                            break;
                    }
                });
                if (name === 'article' && (selectedObjectForAI === null || selectedObjectForAI === void 0 ? void 0 : selectedObjectForAI.name)) {
                    // Performance guard: Only search the tree if the selected AI block also has this block ID.
                    const isSameBlock = !((_a = selectedObjectForAI === null || selectedObjectForAI === void 0 ? void 0 : selectedObjectForAI.block) === null || _a === void 0 ? void 0 : _a.id) || selectedObjectForAI.block.id === data.id;
                    if (isSameBlock && containsMatchingEditable(value, selectedObjectForAI.name)) {
                        attributes.className = `${attributes.className || ''} selectedArticle`.trim();
                    }
                }
                // Define a unique elementKey if it is needed further down.
                const elementKey = `${data.id}_${counter}_${key}`;
                // If the HTML template contained an actual "key" attribute,
                // we filter it out immediately here so that it never ends up in a JSX prop or spread!
                const { key: _ignoredHtmlKey } = attributes, cleanAttributes = __rest(attributes, ["key"]);
                attributes = cleanAttributes;
                const blockDisabled = !isSubmission &&
                    ((_b = data.only_whitelabel_admin_can_modify) !== null && _b !== void 0 ? _b : false) &&
                    !wlAdminUser &&
                    (onlyWhitelabelAdminCanModifyBlocks === null || onlyWhitelabelAdminCanModifyBlocks === void 0 ? void 0 : onlyWhitelabelAdminCanModifyBlocks.includes(data.id));
                if (name === 'a') {
                    ({ name, attributes } = getLinkData({ name, attributes }));
                }
                else if (name === 'html' || name === 'head' || name === 'body') {
                    name = 'div';
                }
                if (name === 'meta') {
                    // skip meta tags
                    return;
                }
                // --- IMAGE EDITABLE ---
                if (name === 'img' && _.includes(attributes.className, 'editable')) {
                    const param = _.find(data.params, ['name', attributes['data-name']]);
                    if (typeof param !== 'undefined') {
                        const usedImage = _.findIndex(usedMedia, (o) => o.blockid === data.id && o.param === param.name);
                        if (usedImage >= 0) {
                            attributes['data-original'] = usedMedia[usedImage].key;
                            attributes['data-thumb'] = usedMedia[usedImage].thumb;
                        }
                    }
                    result.push(_jsx(ImageElementFTs, { id: data.id, name: "img", attributes: attributes, params: data.params, updateParam: updateParam, imageUpload: imageUpload, usedMedia: usedMedia, templateId: settings === null || settings === void 0 ? void 0 : settings.id, rootUser: rootUser, saveDescription: saveDescription, uploadError: props.uploadError, settings: settings, disabled: blockDisabled }, `${data.id}_${counter}`));
                    return;
                }
                // --- SIMPLE ELEMENTS (img/br/hr) ---
                if (['img', 'br', 'hr'].includes(name)) {
                    if (attributes.src !== undefined) {
                        const cdClient = getCorporateDesignClient(editionRV);
                        attributes.src = attributes.src.replace('{logoBlack}', getCorporateDesignLogoUrl(cdClient, 'client_main_logo') || null);
                        attributes.src = attributes.src.replace('{logoWhite}', getCorporateDesignLogoUrl(cdClient, 'client_main_logo_white') || null);
                        attributes.src = attributes.src.replace('{logoColored}', getCorporateDesignLogoUrl(cdClient, 'client_main_logo_multi_colored') || null);
                    }
                    result.push(createElement(name, Object.assign({ key: elementKey }, attributes)));
                    return;
                }
                // --- BLOCK CONTAINER ---
                if (_.includes(attributes.className, 'block-container')) {
                    result.push(_jsx(BlockContainerFTs, { blocks: data.blocks, type: type, appIntl: intl, pageZoom: pageZoom, spaceConsumed: data.space_consumed, spaceTotal: data.container_space, settings: settings, id: data.id, usedMedia: usedMedia, rasterV: rasterV, attributes: attributes, data: data, updateInnerBlock: updateInnerBlock, currentPage: currentPage, setSelectedColor: setSelectedColor, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, getColorSettings: getColorSettings, name: name, children: value.children, index: index, containerSelect: containerSelect, pasteData: pasteData, copiedBlock: copiedBlock, showKeyboard: showKeyboard, isSubmission: isSubmission, wlAdminUser: wlAdminUser, colorSettings: colorSettings, deleteSelectedColor: deleteSelectedColor, imageUpload: imageUpload, resizeBlock: resizeBlock, blockBiggerDisable: blockBiggerDisable, getDeviceType: getDeviceType, uploadError: props.uploadError, copyBlock: copyBlock, pasteBlock: pasteBlock, templateBlocks: templateBlocks, blockPasteDisable: blockPasteDisableBlockContainer, blockContainer: blockContainer, unsetBlockContainer: unsetBlockContainer, publisherInfo: publisherInfo, params: data.params, onlyWhitelabelAdminCanModifyBlocks: onlyWhitelabelAdminCanModifyBlocks, updateBlocksState: updateBlocksState, selectedObjectForAI: selectedObjectForAI, setSelectedObjectForAI: setSelectedObjectForAI }, `${data.id}_${counter}`));
                    return;
                }
                // --- DRAGGABLE CONTAINER ---
                if (_.includes(attributes.className, 'ContainerDraggable')) {
                    result.push(_jsx(DraggableContainerFTs, { appIntl: intl, id: data.id, name: name, index: index, settings: settings, attributes: attributes, children: value.children, blocks: data.blocks, spaceConsumed: data.space_consumed, spaceTotal: data.container_space, data: data, type: type, pageZoom: pageZoom, updateInnerBlock: updateInnerBlock, usedMedia: usedMedia, imageUpload: imageUpload, copyBlock: copyBlock, pasteBlock: pasteBlock, templateBlocks: templateBlocks, containerSelect: containerSelect, unsetBlockContainer: unsetBlockContainer, blockContainer: blockContainer, rasterV: rasterV, pasteData: pasteData, copiedBlock: copiedBlock, publisherInfo: publisherInfo, params: data.params, showKeyboard: showKeyboard, resizeBlock: resizeBlock, blockBiggerDisable: blockBiggerDisable, getDeviceType: getDeviceType, blockPasteDisable: blockPasteDisableBlockContainer, setFontSizeSettings: setFontSizeSettings, fontSizeSettings: fontSizeSettings, currentPage: currentPage, setSelectedColor: setSelectedColor, getColorSettings: getColorSettings, deleteSelectedColor: deleteSelectedColor, colorSettings: colorSettings, wlAdminUser: wlAdminUser, isSubmission: isSubmission, onlyWhitelabelAdminCanModifyBlocks: onlyWhitelabelAdminCanModifyBlocks, updateBlocksState: updateBlocksState, selectedObjectForAI: selectedObjectForAI, setSelectedObjectForAI: setSelectedObjectForAI }, `${data.id}_${counter}`));
                    return;
                }
                if (_.includes(attributes.className, 'dropdownmenu')) {
                    result.push(_jsx(DropdownElementFTs, { appIntl: intl, id: data.id, name: name, attributes: attributes, params: data.params, updateParam: updateParam }, `${data.id}_${counter}`));
                    return;
                }
                // --- EDITABLE TEXT BLOCK ---
                if (_.includes(attributes.className, 'editable')) {
                    result.push(_jsx(Fragment, { children: _jsx(EditableFTs, { appIntl: intl, id: data.id, name: name, settings: settings, attributes: attributes, children: value.children, params: data.params, updateParam: updateParam, publisherInfo: publisherInfo, errors: data.errors, bgColor: bgColorParam, getDeviceType: getDeviceType, showKeyboard: showKeyboard, bigger: data.bigger, resizeBlock: resizeBlock, blockBiggerDisable: blockBiggerDisable, autoResizeSupported: autoResizeSupported, setFontSizeSettings: setFontSizeSettings, disabled: blockDisabled, block: data, setSelectedObjectForAI: setSelectedObjectForAI }) }, `${data.id}_${counter}`));
                    return;
                }
                // --- BACKGROUND OPTIONS ---
                if (_.includes(attributes.className, 'backgroundOptions')) {
                    result.push(_jsx(BackgroundElementFTs, { appIntl: intl, id: data.id, name: name, attributes: attributes, params: data.params, updateParam: updateParam, settings: settings, block: data, value: value, currentPage: currentPage, setSelectedColor: setSelectedColor, blockContainerId: blockContainerId !== null && blockContainerId !== void 0 ? blockContainerId : undefined, colorSettings: colorSettings, updateBlocksState: updateBlocksState }, `${data.id}_${counter}`));
                    return;
                }
                // --- QR CODES ---
                if (_.includes(attributes.className, 'qr-code')) {
                    result.push(_jsx(QRCode, { id: data.id, name: name, attributes: attributes, params: data.params, updateParam: updateParam, settings: settings, variables: qrVariables }, `${data.id}_${counter}`));
                    return;
                }
                if (_.includes(attributes.className, 'qr-logo-code')) {
                    result.push(_jsx(QRCodeWithLogoFTs, { appIntl: intl, id: data.id, name: name, attributes: attributes, params: data.params, updateParam: updateParam, settings: settings, variables: qrVariables }, `${data.id}_${counter}`));
                    return;
                }
                /*
      
                      // --- NAV, CALENDAR, VIDEO, SOCIAL, GALLERY, SLIDERS, CONTACT FORMS, MAPS etc. ---
                      if (_.includes(attributes.className, 'nav')) {
                        result.push(
                          <NavigationElement
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            navEntry={navEntry}
                            resetNavEntry={resetNavEntry}
                            key={`${data.id}_${counter}`}
                            disabled={blockDisabled}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'calendar')) {
                        result.push(
                          <CalendarElement
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            key={`${data.id}_${counter}`}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'cal-optimized')) {
                        result.push(
                          <CalendarElementOptimized
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            key={`${data.id}_${counter}`}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'video')) {
                        result.push(
                          <VideoElement
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            imageUpload={imageUpload}
                            key={`${data.id}_${counter}`}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'socialmedia')) {
                        result.push(
                          <SocialMediaElement
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            key={`${data.id}_${counter}`}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'calendly')) {
                        result.push(
                          <Calendly
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            key={`${data.id}_${counter}`}
                            settings={settings}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'actionButton')) {
                        result.push(
                          <ActionButton
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            key={`${data.id}_${counter}`}
                            settings={settings}
                            navEntry={navEntry}
                            disabled={blockDisabled}
                          />
                        );
                        return;
                      }
      
      
      
                      if (_.includes(attributes.className, 'imagegallery')) {
                        result.push(
                          <ImageGalleryElement
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            updateSpecialBlockAttributes={updateSpecialBlockAttributes}
                            imageUpload={imageUpload}
                            usedMedia={usedMedia}
                            templateId={settings?.id}
                            filesUploading={filesUploading}
                            key={`${data.id}_${counter}`}
                            rootUser={rootUser}
                            saveDescription={saveDescription}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'biggallery')) {
                        result.push(
                          <ImageGalleryElementTwo
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            imageUpload={imageUpload}
                            usedMedia={usedMedia}
                            templateId={settings?.id}
                            filesUploading={filesUploading}
                            key={`${data.id}_${counter}`}
                            rootUser={rootUser}
                            saveDescription={saveDescription}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'textslider')) {
                        result.push(
                          <TextSlider
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            imageUpload={imageUpload}
                            usedMedia={usedMedia}
                            templateId={settings?.id}
                            filesUploading={filesUploading}
                            key={`${data.id}_${counter}`}
                            rootUser={rootUser}
                            saveDescription={saveDescription}
                            disabled={blockDisabled}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'slidertxtbig')) {
                        result.push(
                          <TextSliderTwo
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            imageUpload={imageUpload}
                            usedMedia={usedMedia}
                            templateId={settings?.id}
                            filesUploading={filesUploading}
                            key={`${data.id}_${counter}`}
                            rootUser={rootUser}
                            saveDescription={saveDescription}
                            disabled={blockDisabled}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'contactform')) {
                        result.push(
                          <ContactFormElement
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            imageUpload={imageUpload}
                            usedMedia={usedMedia}
                            filesUploading={filesUploading}
                            key={`${data.id}_${counter}`}
                            disabled={blockDisabled}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'newform')) {
                        result.push(
                          <ContactFormElementNew
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            imageUpload={imageUpload}
                            usedMedia={usedMedia}
                            filesUploading={filesUploading}
                            key={`${data.id}_${counter}`}
                            disabled={blockDisabled}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'newmap')) {
                        result.push(
                          <GoogleMapsElement
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            imageUpload={imageUpload}
                            usedMedia={usedMedia}
                            filesUploading={filesUploading}
                            key={`${data.id}_${counter}`}
                            disabled={blockDisabled}
                          />
                        );
                        return;
                      }
      
                      if (_.includes(attributes.className, 'rssfeeds')) {
                        result.push(
                          <RSSFeedsElement
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            imageUpload={imageUpload}
                            usedMedia={usedMedia}
                            key={`${data.id}_${counter}`}
                          />
                        );
                        return;
                      }
      
      
      
                      // --- CREATOMATE ---
                      if (_.includes(attributes.className, 'creatomate')) {
                        result.push(
                          <Creatomate
                            appIntl={intl}
                            id={data.id}
                            name={name}
                            zoomEqualizer={zoomEqualizer}
                            attributes={attributes}
                            params={data.params}
                            pageZoom={pageZoom}
                            updateParam={updateParam}
                            imageUpload={imageUpload}
                            key={`${data.id}_${counter}`}
                          />
                        );
                        return;
                      }
              */
                if (attributes['data-is-root']) {
                    result = loop(value.children);
                    return;
                }
                // --- fallback: regular element with children ---
                // We explicitly pass the elementKey as a genuine React key
                // and use the cleaned-up spread without an illegal 'key' property!
                result.push(createElement(name, Object.assign({ key: elementKey }, attributes), loop(value.children)));
            }
        });
        return result;
    };
    const doNothing = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    if (data && data.template) {
        try {
            if (typeof data.template !== 'string') {
                console.warn('Invalid template data type:', typeof data.template);
                return (_jsx("div", { className: "rich-editor-content", children: _jsx(Alert, { variant: "warning", children: "Template data is invalid. Please check your editor content." }) }));
            }
            return _jsx(_Fragment, { children: loop(HTML.parse(`<div data-is-root="true">${data.template}</div>`)) });
        }
        catch (e) {
            console.error(e);
            return (_jsx("div", { className: "rich-editor-content", children: _jsx(Alert, { variant: "danger", children: "Incorrect HTML detected. Please check your code in the editor." }) }));
        }
    }
    return null;
};
export default withRouter(connect()(legacyInjectIntl(EditorBlockFTs)));
